import React, { useEffect, useReducer, useRef } from 'react';
import clsx from 'clsx';
import styles from './styles.scss';

export interface IProps {
  className?: string;
}

export interface IState {
  isSticky: boolean;
  stickyPoint: number;
}

export const setStateOnScroll = (
  header: any,
  state: IStickyHeaderState,
): IStickyHeaderState => {
  if (header === null) return state;
  const height = header.current!.getBoundingClientRect().height;
  const top = header.current!.getBoundingClientRect().top;
  return {
    isSticky: state.isSticky
      ? state.stickyPoint > window.scrollY + height
      : top < 0,
    stickyPoint: !state.isSticky ? window.scrollY + top : 0,
  };
};

const stateReducer = (
  state: IStickyHeaderState,
  payload: IStickyHeaderState,
): IStickyHeaderState => {
  return {
    ...state,
    ...payload,
  };
};

const getOriginalStyles = (
  header: any,
  state: IStickyHeaderState,
  extraWidth: boolean,
) => {
  const { isSticky } = state;
  const extraWidthValue = extraWidth ? 1 : 0;
  const width =
    isSticky && header
      ? header.current!.getBoundingClientRect().width + extraWidthValue
      : '';
  const height =
    isSticky && header ? header.current!.getBoundingClientRect().height : '';
  let display = 'none';

  if (isSticky) {
    display = 'inherit';
  }
  return { width, height, display };
};

const renderChildren = (children: React.ReactNode, isSticky: boolean) => {
  if (!children) return <div />;
  if (typeof children === 'string') return children;
  return React.cloneElement(children as React.ReactElement<any>, {
    sticky: isSticky.toString(),
  });
};

const StickyHeader = (props: any) => {
  // extends React.Component<IProps, IState> {
  const { className, children, extraWidth } = props;

  const [state, dispatch] = useReducer(stateReducer, {
    isSticky: false,
    stickyPoint: 0,
  });

  const headerRef = useRef(null);

  const enhancedClassName = clsx(className, {
    [styles['sticky-header']]: state.isSticky,
  });
  const originalStyle = getOriginalStyles(headerRef, state, extraWidth);

  const handleScroll = () => {
    const payload = setStateOnScroll(headerRef, state);
    if (payload) dispatch(payload);
  };

  useEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {state.isSticky && (
        <thead className={enhancedClassName} style={originalStyle}>
          {renderChildren(children, state.isSticky)}
        </thead>
      )}
      <thead ref={headerRef}>{children}</thead>
    </>
  );
};

interface IStickyHeaderState {
  isSticky: boolean;
  stickyPoint: number;
}

export default StickyHeader;
